(function (angular) {
    angular.module('bizPartEngage').controller('modules.certifications', indexController);

    indexController.$inject = ["$stateParams", "$state", "modules.certifications.service", "$rootScope"];

    function indexController($stateParams, $state, certService, $rootScope) {
        var vm = this;

        vm.AuthToken = $rootScope.AuthToken;
        vm.CertList = [];
        vm.NoImageUrl = 'Images/Common/no_img.svg';

        vm.Init = Init;
        vm.GetCertifications = GetCertifications;              

        function GetCertifications() {
            certService.GetCertificationsForUser().then(GetCertificationsForUserSuccess);

            function GetCertificationsForUserSuccess(response) {                
                vm.CertList = BizPartCoreHelpers.getResponseValue(response, []);
                for (var i = 0; i < vm.CertList.length; i++) {                                        
                    
                    var totalXp = 0;
                    for (var j = 0; j < vm.CertList[i].Items.length; j++) {                        
                        totalXp = totalXp + vm.CertList[i].Items[j].Item.ExperienceGive;                        
                    }
                    vm.CertList[i].ExperienceGive = totalXp;
                }                
            }
        }

        function Init() {            
            vm.GetCertifications();
        }

        this.$onInit = vm.Init;
    }

})(window.angular);
